export default {
    name: "OiseauAnimation",
    props: {
        startAnimation: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {}
    },
    computed: {},
    methods: {},
    mounted () {}
};
